import {
  CLOSE_MOBILE_MENU,
  CLOSE_MOBILE_MENU_ACCORDIONS,
  OPEN_MOBILE_MENU,
  TOGGLE_MOBILE_MENU_ACCORDION,
  TOGGLE_MOBILE_MENU_ACCOUNT_MENU,
} from '../actions/mobileMenu'
import {isAccountMenuOpen, openAccordion, wrap} from '../store/mobileMenu'

const initialState = {
  isAccountMenuOpen: false,
  isOpen: false,
  openAccordion: null,
}

export default function reducer(state = initialState, action) {
  let newState

  switch (action.type) {
    case CLOSE_MOBILE_MENU:
      newState = {isOpen: false}
      break
    case CLOSE_MOBILE_MENU_ACCORDIONS:
      newState = {openAccordion: null}
      break
    case OPEN_MOBILE_MENU:
      newState = {isOpen: true}
      break
    case TOGGLE_MOBILE_MENU_ACCORDION:
      // if id is the same, close; if different, set the new id as open
      newState = {
        openAccordion:
          openAccordion(wrap(state)) === action.accordionId ? null : action.accordionId,
      }
      break
    case TOGGLE_MOBILE_MENU_ACCOUNT_MENU:
      newState = {isAccountMenuOpen: !isAccountMenuOpen(wrap(state))}
      break
    default:
      break
  }

  return newState ? Object.assign({}, state, newState) : state
}
